import { styled } from 'styled-system/jsx'

const FieldContainer = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
})

const FieldLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    color: 'quickpass.ink',
  },
})

const TilesGrid = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
    gap: '10px',
  },
})

const Tile = styled('button', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left',
    gap: '6px',
    paddingX: '16px',
    paddingY: '14px',
    borderRadius: 'md',
    border: '1.5px solid',
    cursor: 'pointer',
    transition:
      'transform {durations.fast} {easings.appleStandard}, background-color {durations.fast} {easings.appleStandard}, border-color {durations.fast} {easings.appleStandard}, box-shadow {durations.fast} {easings.appleStandard}',
    _active: {
      transform: 'scale(0.98)',
    },
  },
  variants: {
    isSelected: {
      true: {
        backgroundColor: 'quickpass.surfaceCool',
        borderColor: 'quickpass.primary',
        boxShadow: '0 6px 20px -10px rgba(128, 84, 255, 0.45)',
      },
      false: {
        backgroundColor: '#FFFFFF',
        borderColor: '#E5E0F5',
        _hover: {
          borderColor: 'quickpass.primary',
        },
      },
    },
  },
})

const TileEmoji = styled('span', {
  base: {
    fontSize: '24px',
    lineHeight: '1',
  },
})

const TileTitle = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '16px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const TileDescription = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    lineHeight: '1.4',
  },
})

const HelperText = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
  },
})

export {
  FieldContainer,
  FieldLabel,
  TilesGrid,
  Tile,
  TileEmoji,
  TileTitle,
  TileDescription,
  HelperText,
}
